<template>
  <AppButton class="item" variant="gradient">
    <AppTitle v-if="description" v-text="description"/>
    <b v-if="name" v-text="name"/>
  </AppButton>
</template>


<script>
import AppTitle from '@/components/game/ui/AppTitle';
import AppButton from '@/components/game/ui/AppButton';

export default {
  name: 'PrizeItem',

  components: {
    AppButton,
    AppTitle,
  },

  props: {
    name: String,
    description: String,
  },
};
</script>


<style lang="scss" scoped>
button.item {
  aspect-ratio: 3;
  border-radius: 8px !important;
  min-height: unset;

  h1 {
    font-size: 14px;
  }

  b {
    font-size: 16px;
    line-height: 1.05;
    font-weight: bold;
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    border-radius: 12px !important;

    h1 {
      font-size: 18px;
    }

    b {
      font-size: 24px;
    }
  }
}
</style>